import { get } from "services/httpService";

const SERVICE_URLS = {
  paymentCheckout: (priceId, callbackPath) =>
    `stripe-checkout/${priceId}?path=${callbackPath}`,
  updatePaymentMethod: () => `user/update-payment-method/`,
};

export const paymentCheckout = (priceId, callbackPath) =>
  get(SERVICE_URLS.paymentCheckout(priceId, callbackPath));

export const updatePaymentMethod = () =>
  get(SERVICE_URLS.updatePaymentMethod());
